import { render, staticRenderFns } from "./appGendersSelect.vue?vue&type=template&id=6eff5dfc"
import script from "./appGendersSelect.vue?vue&type=script&lang=js"
export * from "./appGendersSelect.vue?vue&type=script&lang=js"
import style0 from "./appGendersSelect.vue?vue&type=style&index=0&id=6eff5dfc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports